var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYourGardensSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plant1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plant1SecondaryVines"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M40.6893 119.803C40.6893 119.803 37.9928 114 38.4211 105.35C38.8222 97.2466 42.5358 94.1071 41.7967 85.2149C41.0572 76.323 38.02 75.1359 36.5071 69.871C34.3626 62.4076 35.606 62.3859 35.376 56.6367C35.0628 48.8086 36.4172 40.1183 42.14 38.0373C46.7669 36.3548 50.0924 39.8953 51.5045 44.1316",
    stroke: "#208820",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M37.0099 121.637C37.0099 121.637 40.3093 111.824 43.1405 107.077C45.9715 102.33 47.6188 102.947 49.3093 103.306C52.2047 103.921 52.6553 103.367 53.879 106.035C54.844 108.14 53.3792 109.738 52.8469 110.739",
    stroke: "#208820",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M40.0368 121.136C40.0368 121.136 39.4113 118.686 40.8264 113.508C42.2414 108.329 43.3494 105.897 45.9911 100.889C48.6325 95.8822 48.6732 96.099 50.9704 92.286C53.2673 88.473 53.0924 89.0344 54.677 85.3954C55.6626 83.1325 56.5441 81.0337 56.6666 77.5857C56.7551 75.1005 55.0816 73.6579 55.5642 70.9705C56.0464 68.2831 58.5961 66.8361 58.5961 66.8361",
    stroke: "#208820",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M40.1792 117.9C40.1792 117.9 40.4147 116.037 40.5897 112.17C40.7648 108.303 42.2481 107.694 40.9213 103.344C39.6973 99.3308 37.817 99.1427 35.3496 96.9029C32.8825 94.6635 33.005 95.7832 32.1302 93.3334C31.2554 90.8839 31.0682 89.424 31.8501 87.1043C32.5922 84.9035 34.4153 83.7434 35.7416 83.4946",
    stroke: "#208820",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M40.0456 122.763C40.0456 122.763 39.477 120.844 40.2352 114.708C40.9934 108.572 41.7516 104.686 43.0781 98.2187C44.405 91.7508 44.3575 94.5463 45.542 88.8369C46.7268 83.1273 47.4771 82.4534 47.8163 75.38C47.9897 71.7677 44.9941 68.874 42.699 68.4624C39.3161 67.8554 36.9185 70.4997 33.4122 70.0731C29.9057 69.6469 29.603 68.4302 27.2468 65.3839C25.1042 62.6145 23.367 60.3123 23.367 60.3123",
    stroke: "#208820",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plant1Fruit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M36.3079 94.0989C36.3079 92.3941 37.6066 91.0122 39.2086 91.0122C40.8105 91.0122 42.1093 92.3941 42.1093 94.0989C42.1093 95.8037 40.8105 97.1856 39.2086 97.1856C37.6066 97.1856 36.3079 95.8037 36.3079 94.0989Z",
    fill: "#FF4A2F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M47.1844 55.5293C47.1844 54.7421 47.8225 54.104 48.6097 54.104C49.3969 54.104 50.0353 54.7421 50.0353 55.5293C50.0353 56.3165 49.3969 56.9549 48.6097 56.9549C47.8225 56.9549 47.1844 56.3165 47.1844 55.5293Z",
    fill: "#FF4A2F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M49.0673 103.724C49.0673 102.686 49.909 101.845 50.9467 101.845C51.9847 101.845 52.8261 102.686 52.8261 103.724C52.8261 104.762 51.9847 105.604 50.9467 105.604C49.909 105.604 49.0673 104.762 49.0673 103.724Z",
    fill: "#FF5A2F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M28.0453 45.3486C28.0453 44.1363 29.0125 43.1537 30.2057 43.1537C31.3986 43.1537 32.3657 44.1363 32.3657 45.3486C32.3657 46.5609 31.3986 47.5439 30.2057 47.5439C29.0125 47.5439 28.0453 46.5609 28.0453 45.3486Z",
    fill: "#E2363B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M47.5925 83.0356C47.5925 81.3182 48.9284 79.9257 50.5761 79.9257C52.224 79.9257 53.5597 81.3182 53.5597 83.0356C53.5597 84.7529 52.224 86.1451 50.5761 86.1451C48.9284 86.1451 47.5925 84.7529 47.5925 83.0356Z",
    fill: "#F45139"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M38.9411 67.7203C38.9411 66.0026 40.2771 64.6105 41.9247 64.6105C43.5727 64.6105 44.9083 66.0026 44.9083 67.7203C44.9083 69.4377 43.5727 70.8299 41.9247 70.8299C40.2771 70.8299 38.9411 69.4377 38.9411 67.7203Z",
    fill: "#FF2F35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M37.9808 105.768C37.9808 104.428 39.0671 103.342 40.4074 103.342C41.7475 103.342 42.8338 104.428 42.8338 105.768C42.8338 107.108 41.7475 108.195 40.4074 108.195C39.0671 108.195 37.9808 107.108 37.9808 105.768Z",
    fill: "#E42A30"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plant1PrimaryVines"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M42.8103 130.13C42.0973 129.267 41.4747 126.963 41.0306 124.873C40.5864 122.784 40.3204 120.91 40.3204 120.91C39.8514 118.533 39.842 115.363 40.3008 112.04C40.7596 108.717 41.6862 105.243 43.0893 102.259C44.5216 99.2133 45.2285 97.0652 45.5789 95.2037C45.9293 93.3422 45.9231 91.7669 45.9293 89.8658C45.9416 86.0294 45.2036 82.3128 44.0933 78.9741C42.9829 75.6352 41.5002 72.6738 40.0233 70.348C37.1947 65.8928 34.8038 62.4486 32.8995 59.4627C30.9952 56.4765 29.625 53.9323 28.6966 51.3261C26.9183 46.3342 26.9041 42.4225 27.2014 37.9632C27.5228 33.1424 30.6158 23.5665 34.3078 21.925",
    stroke: "#00A000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M43.0893 102.259C43.0893 102.259 42.5388 92.8547 38.739 90.5057C33.994 87.5725 29.3355 90.8508 29.3355 90.8508",
    stroke: "#00A000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M40.3204 120.91C42.5156 120.414 39.486 117.553 38.4876 116.157C36.6009 113.519 36.4632 109.216 35.5485 107.329C34.6342 105.443 31.9614 105.702 30.7767 106.564",
    stroke: "#00A000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M46.6846 95.7727C46.6846 95.7727 47.2315 88.611 48.2139 83.4905C49.4892 76.8439 50.3757 72.9973 51.0598 68.274C52.0251 61.6081 51.9586 57.1515 49.0324 52.5322C45.9688 47.6965 38.8471 51.0809 38.8471 51.0809",
    stroke: "#00A000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M40.3204 120.91C40.3204 120.91 41.0024 114.915 43.0893 111.128C45.1758 107.341 47.7747 104.034 49.5176 102.259C51.832 99.9029 53.2301 97.1927 54.3047 94.909C55.3796 92.6253 55.2208 87.1573 55.2208 87.1573",
    stroke: "#00A000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Plant2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plant2SecondaryVines"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M77.4967 124.187C77.4967 124.187 77.1598 121.76 76.7285 118.261C76.2976 114.762 75.7728 110.19 75.397 105.899C74.9906 101.26 75.16 98.3133 75.5889 95.9798C76.0178 93.646 76.7065 91.9248 77.3388 89.7357C78.4201 85.9904 79.0017 83.3599 79.2533 81.1318C79.505 78.9041 79.427 77.0792 79.19 74.9455C78.953 72.8118 78.5487 71.2793 78.0759 69.8443C77.6027 68.4091 77.061 67.0714 76.5483 65.3273C75.8183 62.8433 75.7641 61.0324 76.1077 59.4727C76.4514 57.9129 76.5149 56.6013 77.3757 55.1209C78.0413 53.9757 78.4664 53.3417 80.482 52.2407C83.2277 50.741 85.2094 50.7961 87.3562 49.585C89.5031 48.3741 90.549 47.8462 91.6497 44.5761C92.4647 42.1544 91.7358 34.7303 83.86 37.8478",
    stroke: "#208820",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M75.7937 118.116C75.7937 118.116 76.8899 115.167 78.5083 111.852C80.1264 108.537 77.6722 113.5 80.5494 106.658C81.8991 103.447 83.5746 100.808 87.4869 101.203",
    stroke: "#208820",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M75.5051 117.069C75.5051 117.069 75.4192 114.035 74.9426 110.902C74.6112 108.724 74.0818 106.503 73.1906 104.604C72.1017 102.284 71.0452 101.07 68.5453 98.99C66.0454 96.9103 65.8134 97.5311 64.0655 95.2304C62.3174 92.9297 61.5173 92.2998 61.5536 89.7873C61.5902 87.2751 63.7682 86.0912 65.7469 88.4215",
    stroke: "#208820",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M68.3027 127.933C68.3027 127.933 73.6966 122.721 74.2201 114.733C74.7437 106.745 74.4932 96.3436 73.856 93.2484C73.2188 90.1532 73.1959 87.0809 70.6696 80.6856C68.1434 74.2904 66.2089 72.5153 63.4778 67.5765C60.7468 62.6379 58.926 62.5014 57.6516 58.1089C56.3771 53.7164 58.3799 50.0065 58.3799 50.0065",
    stroke: "#208820",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M74.9924 121.528C74.9924 121.528 74.4964 118.953 75.4767 113.296C76.7356 106.034 77.4861 104.69 79.2533 98.9643C81.0208 93.2388 80.5603 95.3057 81.7711 92.3795C82.3521 90.9753 82.8152 90.2935 83.9016 89.7164C85.4511 88.8932 87.7538 89.7349 88.8888 88.7481C90.0024 87.7796 89.9783 86.678 89.1794 85.4555C88.3805 84.2329 85.6447 83.2767 84.1436 84.3902",
    stroke: "#208820",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plant2Fruit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M67.2413 84.7658C67.2413 83.4568 68.3883 82.3954 69.803 82.3954C71.2178 82.3954 72.3647 83.4568 72.3647 84.7658C72.3647 86.0751 71.2178 87.1365 69.803 87.1365C68.3883 87.1365 67.2413 86.0751 67.2413 84.7658Z",
    fill: "#A32D59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M83.7583 107.285C83.7583 106.377 84.4773 105.641 85.3641 105.641C86.2509 105.641 86.9698 106.377 86.9698 107.285C86.9698 108.193 86.2509 108.929 85.3641 108.929C84.4773 108.929 83.7583 108.193 83.7583 107.285Z",
    fill: "#AA0D37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M65.712 58.7291C65.712 57.3144 66.842 56.1677 68.2356 56.1677C69.629 56.1677 70.759 57.3144 70.759 58.7291C70.759 60.1439 69.629 61.2908 68.2356 61.2908C66.842 61.2908 65.712 60.1439 65.712 58.7291Z",
    fill: "#AA0D47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M69.3062 109.579C69.3062 108.671 70.0421 107.935 70.95 107.935C71.8579 107.935 72.5941 108.671 72.5941 109.579C72.5941 110.487 71.8579 111.223 70.95 111.223C70.0421 111.223 69.3062 110.487 69.3062 109.579Z",
    fill: "#D23971"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M76.4939 84.307C76.4939 82.829 77.6235 81.6308 79.0172 81.6308C80.4108 81.6308 81.5405 82.829 81.5405 84.307C81.5405 85.7854 80.4108 86.9836 79.0172 86.9836C77.6235 86.9836 76.4939 85.7854 76.4939 84.307Z",
    fill: "#AA0D1F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M77.7173 66.7198C77.7173 65.2418 78.8643 64.0435 80.279 64.0435C81.6938 64.0435 82.8407 65.2418 82.8407 66.7198C82.8407 68.1978 81.6938 69.3961 80.279 69.3961C78.8643 69.3961 77.7173 68.1978 77.7173 66.7198Z",
    fill: "#9F214F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M65.2966 30.5209C65.2966 29.3106 66.2288 28.3294 67.3784 28.3294C68.5283 28.3294 69.4603 29.3106 69.4603 30.5209C69.4603 31.7312 68.5283 32.7123 67.3784 32.7123C66.2288 32.7123 65.2966 31.7312 65.2966 30.5209Z",
    fill: "#961F4B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plant2PrimaryVines"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M76.6849 128.351C76.6849 128.351 76.6649 128.3 76.6301 128.2C76.5949 128.099 76.5451 127.949 76.4854 127.751C76.4253 127.553 76.3556 127.306 76.2806 127.012C76.2059 126.718 76.1259 126.377 76.0459 125.99C75.9662 125.603 75.8862 125.17 75.8115 124.692C75.7365 124.215 75.6668 123.692 75.6067 123.127C75.547 122.561 75.4969 121.951 75.462 121.3C75.4272 120.648 75.4072 119.954 75.4072 119.219C75.4072 118.225 75.4805 117.359 75.6059 116.592C75.7315 115.824 75.9094 115.155 76.1186 114.556C76.328 113.956 76.5686 113.426 76.8193 112.935C77.0704 112.445 77.3317 111.995 77.5825 111.555C77.8333 111.115 78.0732 110.687 78.2818 110.239C78.4904 109.792 78.6677 109.326 78.7922 108.813C78.9167 108.299 78.9888 107.738 78.9873 107.099C78.9861 106.461 78.9111 105.745 78.7418 104.924C78.5725 104.102 78.3656 103.381 78.1348 102.734C77.9039 102.086 77.6493 101.51 77.3851 100.979C77.1208 100.447 76.8469 99.9592 76.5768 99.4857C76.3069 99.0123 76.0412 98.5535 75.7937 98.0804C75.5461 97.6072 75.3167 97.12 75.1195 96.5895C74.9221 96.0589 74.7571 95.485 74.6379 94.839C74.519 94.193 74.4457 93.4749 74.4328 92.6558C74.4199 91.8363 74.4671 90.9161 74.5881 89.8658C74.7094 88.8155 74.8796 87.8775 75.0905 87.0223C75.3012 86.1674 75.5528 85.3957 75.8367 84.6779C76.1206 83.9602 76.4367 83.2966 76.7766 82.6579C77.1167 82.0192 77.4806 81.4055 77.86 80.7876C78.2394 80.1697 78.6343 79.5478 79.0359 78.8927C79.4379 78.2373 79.8469 77.5488 80.2547 76.798C80.6625 76.0471 81.0689 75.2341 81.4655 74.3294C81.8622 73.4247 82.2489 72.4286 82.6178 71.3121C82.9866 70.1956 83.1442 69.0457 83.1378 67.8888C83.1311 66.7316 82.9603 65.567 82.6723 64.4209C82.3846 63.2745 81.9794 62.1469 81.5042 61.0629C81.029 59.9792 80.4838 58.9395 79.9154 57.9694C79.3471 56.9994 74.3314 50.9016 71.3648 45.5449C68.7894 40.8952 63.784 32.4085 64.5249 28.4864C65.9256 21.0696 76.227 21.7288 75.4852 27.5799",
    stroke: "#00A000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M74.4006 95.7727C72.0636 91.8495 70.9843 86.6388 65.8523 84.4272C63.2361 83.2998 61.4001 81.2567 61.3898 77.9441C61.3731 72.5684 66.7784 71.2084 66.7784 71.2084",
    stroke: "#00A000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M73.4941 117.609C74.0449 115.552 72.8678 107.977 70.4186 105.382C70.4186 105.382 67.2325 101.939 64.604 105.78",
    stroke: "#00A000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M74.4006 95.7727C73.8246 92.4056 71.8521 88.2741 72.0967 82.3043C72.2508 78.5417 75.5848 79.2401 73.3301 71.8978C71.0754 64.5554 64.6386 59.3133 63.0776 52.9345C61.5164 46.5557 67.086 46.3822 67.086 46.3822",
    stroke: "#00A000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M75.4072 119.219C75.4072 119.219 75.5452 115.25 77.7615 113.025C79.9778 110.8 81.7119 112.312 84.2722 110.318C86.8324 108.325 88.0028 105.051 88.0028 105.051",
    stroke: "#00A000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Plant3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plant3SecondaryVines"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M114.819 123.154L114.574 117.365C114.574 117.365 114.758 113.981 116.205 112.146C117.652 110.312 119.028 109.698 120.363 110.026C121.807 110.382 122.653 112.219 121.837 113.24",
    stroke: "#208820",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M114.292 123.295L112.449 114.558C112.449 114.558 110.589 106.282 111.221 101.862C111.852 97.4426 112.91 99.7292 114.975 96.8795C117.039 94.0298 117.278 93.0741 119.479 90.4632C121.681 87.8525 122.159 88.3644 123.78 86.436C125.401 84.508 125.162 85.3781 125.964 82.7502C126.766 80.1223 126.988 75.9246 126.988 75.9246C126.988 75.9246 125.691 72.7679 124.326 70.8735C122.961 68.9795 121.527 68.3481 121.527 68.3481",
    stroke: "#208820",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M111.818 120.52C111.818 120.52 112.075 119.488 112.138 117.984C112.201 116.479 112.069 114.5 111.291 112.606C110.699 111.168 110.234 109.941 109.831 108.665C109.428 107.389 109.086 106.064 108.741 104.428C108.319 102.433 107.925 100.641 107.856 98.7483C107.786 96.8561 108.041 94.8642 108.916 92.4697C109.577 90.6627 110.174 89.562 110.615 88.4306C111.056 87.2988 111.341 86.136 111.379 84.2042C111.434 81.3243 111.3 78.8848 110.966 76.5384C110.632 74.192 110.098 71.9388 109.356 69.4315C108.321 65.932 107.359 63.8326 106.697 61.9213C106.035 60.0097 105.674 58.2861 105.839 55.5384C106.004 52.7906 106.856 50.9771 107.845 49.7464C108.835 48.5153 109.961 47.867 110.675 47.4486C112.378 46.4502 114.106 45.056 114.718 42.6788C115.793 38.4961 113.019 33.5136 114.446 30.5895",
    stroke: "#208820",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M106.759 118.92C106.759 118.92 109.193 117.467 109.429 116.368C109.651 115.331 109.447 113.091 107.341 111.245C105.236 109.399 105.486 109.693 103.337 108.352C101.188 107.01 100.535 105.938 98.7466 105.88C96.411 105.805 95.5893 105.664 94.3491 106.832C93.109 108 93.786 110.553 93.786 110.553",
    stroke: "#208820",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M114.456 125.869L111.667 113.166C111.667 113.166 109.235 109.816 107.274 107.111C105.553 104.737 105.301 103.416 105.018 99.5728C104.737 95.7293 105.137 94.0377 105.018 90.7283C104.9 87.4192 104.722 89.4226 104.544 86.3358C104.434 84.4395 103.67 81.3059 102.822 77.4914C102.11 74.286 101.16 72.3272 98.7267 70.3685C96.293 68.4097 94.1561 67.9942 92.0191 68.647C89.8822 69.3 89.7337 69.7898 88.9324 71.3774C88.1312 72.9653 88.6948 77.6104 88.6948 77.6104",
    stroke: "#208820",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M113.475 118.426L110.652 113.421L105.84 107.517C105.84 107.517 101.989 103.603 100.45 101.358C99.4219 99.8587 99.2625 98.5822 97.7546 96.2883C96.2467 93.9943 94.7253 94.2563 94.418 92.1817C94.1613 90.4491 94.7388 88.4602 94.7388 88.4602",
    stroke: "#208820",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plant3Fruit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M99.4017 89.3074C99.4017 88.2601 100.236 87.411 101.265 87.411C102.294 87.411 103.128 88.2601 103.128 89.3074C103.128 90.3548 102.294 91.2038 101.265 91.2038C100.236 91.2038 99.4017 90.3548 99.4017 89.3074Z",
    fill: "#EC6120"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M111.046 101.917C111.046 100.52 112.148 99.3879 113.508 99.3879C114.867 99.3879 115.97 100.52 115.97 101.917C115.97 103.313 114.867 104.445 113.508 104.445C112.148 104.445 111.046 103.313 111.046 101.917Z",
    fill: "#EC6E20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M115.77 75.5007C115.77 74.2878 116.813 73.3049 118.099 73.3049C119.385 73.3049 120.428 74.2878 120.428 75.5007C120.428 76.7133 119.385 77.6965 118.099 77.6965C116.813 77.6965 115.77 76.7133 115.77 75.5007Z",
    fill: "#EC6E20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M106.322 53.2102C106.322 52.328 107.096 51.6132 108.052 51.6132C109.007 51.6132 109.782 52.328 109.782 53.2102C109.782 54.092 109.007 54.8071 108.052 54.8071C107.096 54.8071 106.322 54.092 106.322 53.2102Z",
    fill: "#ECA320"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M98.0042 109.602C98.0042 108.444 98.9429 107.506 100.1 107.506C101.258 107.506 102.196 108.444 102.196 109.602C102.196 110.759 101.258 111.698 100.1 111.698C98.9429 111.698 98.0042 110.759 98.0042 109.602Z",
    fill: "#EC6E20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M93.2136 73.2384C93.2136 71.8418 94.2861 70.7098 95.6089 70.7098C96.9319 70.7098 98.0042 71.8418 98.0042 73.2384C98.0042 74.6347 96.9319 75.7667 95.6089 75.7667C94.2861 75.7667 93.2136 74.6347 93.2136 73.2384Z",
    fill: "#CF6524"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M107.054 75.9662C107.054 74.717 108.022 73.7039 109.216 73.7039C110.411 73.7039 111.379 74.717 111.379 75.9662C111.379 77.2157 110.411 78.2288 109.216 78.2288C108.022 78.2288 107.054 77.2157 107.054 75.9662Z",
    fill: "#EC8C20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M101.038 38.0851C101.038 36.9703 101.941 36.0665 103.056 36.0665C104.171 36.0665 105.075 36.9703 105.075 38.0851C105.075 39.1998 104.171 40.1036 103.056 40.1036C101.941 40.1036 101.038 39.1998 101.038 38.0851Z",
    fill: "#DB6B26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plant3PrimaryVines"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M112.364 125.331C112.364 125.331 112.515 125.012 112.715 124.469C112.915 123.927 113.165 123.161 113.364 122.268C113.562 121.376 113.709 120.357 113.703 119.307C113.697 118.257 113.539 117.177 113.127 116.163C112.858 115.502 112.445 114.848 111.95 114.21C111.455 113.573 110.878 112.95 110.281 112.353C109.685 111.755 109.069 111.181 108.496 110.641C107.923 110.099 107.394 109.591 106.971 109.124C106.48 108.584 106.015 107.991 105.592 107.349C105.17 106.708 104.79 106.018 104.47 105.284C104.15 104.55 103.89 103.771 103.707 102.951C103.524 102.131 103.419 101.271 103.407 100.373C103.391 99.034 103.533 97.7695 103.768 96.5771C104.002 95.3845 104.328 94.2639 104.677 93.2118C105.028 92.1595 105.402 91.176 105.732 90.2572C106.063 89.3388 106.351 88.4851 106.527 87.6932C106.762 86.6426 107.009 85.7502 107.204 84.8839C107.4 84.0176 107.544 83.1771 107.571 82.2299C107.598 81.2827 107.509 80.2289 107.239 78.9363C106.97 77.6435 106.519 76.1115 105.823 74.2078C105.265 72.6823 104.559 71.3534 103.773 70.0893C102.986 68.8251 102.12 67.6257 101.241 66.3592C100.363 65.0924 99.4714 63.7588 98.6355 62.226C97.8 60.6932 97.0198 58.9611 96.363 56.8983C95.6854 54.7702 95.4076 52.314 95.4794 49.8879C95.5512 47.4618 96.508 43.5891 99.1737 40.0345C101.103 37.4625 105.4 33.3513 106.357 28.0383C107.485 21.7745 105.319 14.9456 99.6621 11.7894",
    stroke: "#00A000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M113.127 116.163C113.127 116.163 111.995 111.458 115.509 105.907C117.818 102.259 122.51 98.5614 122.51 92.6253C122.51 90.8771 120.826 87.1573 119.623 83.9194C118.097 79.8164 117.551 79.0169 115.537 74.3396C114.133 71.0774 114.133 67.507 115.115 64.0553C116.677 58.5606 120.045 51.9395 120.045 51.9395",
    stroke: "#00A000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M105.823 74.2078C105.43 72.644 104.661 71.3139 104.251 67.9518C103.84 64.5897 105.353 64.962 106.789 61.6081C108.224 58.2539 109.868 57.7497 109.99 54.5355C110.112 51.3261 108.791 49.1074 104.586 49.9295",
    stroke: "#00A000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M112.953 113.519C112.953 113.519 113.21 108.774 114.133 104.034C115.056 99.293 116.719 98.0669 116.645 94.5565C116.571 91.0459 113.836 89.9918 113.836 89.9918",
    stroke: "#00A000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M113.723 123.223C113.723 123.223 111.978 120.546 110.86 117.722C110.01 115.574 108.865 114.129 107.09 113.041C105.316 111.953 103.654 110.933 102.246 109.997C100.839 109.061 99.6864 108.209 98.93 107.458C97.5835 106.123 97.0014 104.697 96.7561 103.605C96.5106 102.513 96.6018 101.755 96.6018 101.755",
    stroke: "#00A000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M103.966 95.485C103.966 95.485 104.612 89.6675 101.933 87.1573C100.192 85.5258 97.5633 85.9315 96.1362 83.0628C93.9188 78.6047 94.5366 76.6447 93.2754 72.8241C92.0145 69.0035 91.0922 67.7801 91.0922 67.7801",
    stroke: "#00A000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "DirtClumps"
  }, /*#__PURE__*/React.createElement("path", {
    id: "DirtClump1",
    d: "M15.794 124.543C10.4507 122.659 24.7508 116.374 34.8609 116.163C44.9707 115.951 61.0008 121.602 56.2342 123.697C51.4673 125.792 21.1373 126.427 15.794 124.543Z",
    fill: "#9E7248"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DirtClump2",
    d: "M55.3342 124.543C49.991 122.659 64.2911 116.374 74.4009 116.163C84.5109 115.951 100.541 121.602 95.7741 123.697C91.0075 125.792 60.6776 126.427 55.3342 124.543Z",
    fill: "#9E7248"
  }), /*#__PURE__*/React.createElement("path", {
    id: "DirtClump3",
    d: "M94.06 124.543C88.7168 122.659 103.017 116.374 113.127 116.163C123.237 115.951 139.267 121.602 134.5 123.697C129.733 125.792 99.4034 126.427 94.06 124.543Z",
    fill: "#9E7248"
  })), /*#__PURE__*/React.createElement("g", {
    id: "MiddleSlat"
  }, /*#__PURE__*/React.createElement("path", {
    id: "MiddleSlatBulk",
    d: "M10.8996 75H138.277C139.854 75 141.132 76.2782 141.132 77.855V79.2281C141.132 80.8049 139.854 82.0831 138.277 82.0831H10.8996C9.32285 82.0831 8.04463 80.8049 8.04463 79.2281V77.855C8.04463 76.2782 9.32285 75 10.8996 75Z",
    fill: "#AC8348"
  }), /*#__PURE__*/React.createElement("path", {
    id: "MiddleSlatShading",
    d: "M141.132 79.2281C141.132 80.8049 139.854 82.0831 138.277 82.0831H10.8996C9.32285 82.0831 8.04463 80.8049 8.04463 79.2281H141.132Z",
    fill: "#99733C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TopSlat"
  }, /*#__PURE__*/React.createElement("path", {
    id: "TopSlatBulk",
    d: "M10.8996 58.0664H138.277C139.854 58.0664 141.132 59.3446 141.132 60.9214V62.2945C141.132 63.8713 139.854 65.1495 138.277 65.1495H10.8996C9.32285 65.1495 8.04463 63.8713 8.04463 62.2945V60.9214C8.04463 59.3446 9.32285 58.0664 10.8996 58.0664Z",
    fill: "#AC8348"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TopSlatShading",
    d: "M141.132 62.2945C141.132 63.8713 139.854 65.1495 138.277 65.1495H10.8996C9.32285 65.1495 8.04463 63.8713 8.04463 62.2945H141.132Z",
    fill: "#99733C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "BottomSlat"
  }, /*#__PURE__*/React.createElement("path", {
    id: "BottomSlatBulk",
    d: "M10.8996 92.6253H138.277C139.854 92.6253 141.132 93.9035 141.132 95.4803V96.8537C141.132 98.4305 139.854 99.7087 138.277 99.7087H10.8996C9.32285 99.7087 8.04463 98.4305 8.04463 96.8537V95.4803C8.04463 93.9035 9.32285 92.6253 10.8996 92.6253Z",
    fill: "#AC8348"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BottomSlatShading",
    d: "M141.132 96.8537C141.132 98.4305 139.854 99.7087 138.277 99.7087H10.8996C9.32285 99.7087 8.04463 98.4305 8.04463 96.8537H141.132Z",
    fill: "#99733C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LeftPost"
  }, /*#__PURE__*/React.createElement("path", {
    id: "LeftPostBulk",
    d: "M18.5575 51.3261H23.7199C25.2966 51.3261 26.5749 52.6043 26.5749 54.1811V125.55C26.5749 127.127 25.2966 128.405 23.7199 128.405H18.5575C16.9807 128.405 15.7025 127.127 15.7025 125.55V54.1811C15.7025 52.6043 16.9807 51.3261 18.5575 51.3261Z",
    fill: "#B88D4F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "LeftPostShading",
    d: "M23.7199 51.3261C25.2966 51.3261 26.5749 52.6043 26.5749 54.1811V125.55C26.5749 127.127 25.2966 128.405 23.7199 128.405V51.3261Z",
    fill: "#B0874B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "LeftPostHighlight",
    d: "M18.5575 51.3261V128.405C16.9807 128.405 15.7025 127.127 15.7025 125.55V54.1811C15.7025 52.6043 16.9807 51.3261 18.5575 51.3261Z",
    fill: "#CA9C59"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RightPost"
  }, /*#__PURE__*/React.createElement("path", {
    id: "RightPostBulk",
    d: "M126.235 51.3261H131.397C132.974 51.3261 134.252 52.6043 134.252 54.1811V125.55C134.252 127.127 132.974 128.405 131.397 128.405H126.235C124.658 128.405 123.38 127.127 123.38 125.55V54.1811C123.38 52.6043 124.658 51.3261 126.235 51.3261Z",
    fill: "#B88D4F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "RightPostShading",
    d: "M131.397 51.3261C132.974 51.3261 134.252 52.6043 134.252 54.1811V125.55C134.252 127.127 132.974 128.405 131.397 128.405V51.3261Z",
    fill: "#B0874B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "RightPostHighlight",
    d: "M126.235 51.3261V128.405C124.658 128.405 123.38 127.127 123.38 125.55V54.1811C123.38 52.6043 124.658 51.3261 126.235 51.3261Z",
    fill: "#CA9C59"
  })), /*#__PURE__*/React.createElement("g", {
    id: "BottomDirt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "BulkDirt",
    d: "M16.9498 120.91H133.05C137.064 120.91 140.317 124.164 140.317 128.177V128.634C140.317 132.647 137.064 135.901 133.05 135.901H16.9498C12.9362 135.901 9.68262 132.647 9.68262 128.634V128.177C9.68262 124.164 12.9362 120.91 16.9498 120.91Z",
    fill: "#835E3C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TopDirtShading",
    d: "M16.9498 120.91H45.975H75H104.025H133.05C134.054 120.91 135.009 121.113 135.879 121.481C136.748 121.849 137.531 122.381 138.189 123.038C138.846 123.696 11.1536 123.696 11.8111 123.038C12.4687 122.381 13.2517 121.849 14.1211 121.481C14.9905 121.113 15.9464 120.91 16.9498 120.91Z",
    fill: "#8F6641"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BottomDirtShading",
    d: "M139.746 131.462C139.378 132.332 138.846 133.115 138.189 133.772C137.531 134.43 136.748 134.962 135.879 135.33C135.009 135.698 134.054 135.901 133.05 135.901H104.025H75H45.975H16.9498C15.9464 135.901 14.9905 135.698 14.1211 135.33C13.2516 134.962 12.4687 134.43 11.8111 133.772C11.1536 133.115 10.6214 132.332 10.2537 131.462C9.88597 130.593 140.114 130.593 139.746 131.462Z",
    fill: "#765536"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYourGardensSvg);
export default __webpack_public_path__ + "static/media/YourGardensSVG.19a67f4e0a5a16d24ebb726d96fdbb2d.svg";
export { ForwardRef as ReactComponent };